import React, { useState, useEffect } from "react";
import { inputFormat, inputCustomFormat, billPlease, moneyFormat } from "../../ultil";
import _ from "lodash";
import Loading from "../Loading";
import InputCustom from "../Input/InputCustom";
import TextTitle from "../Text/TextTitle";
import TextTitle1 from "../Text/TextTitle1";
import TextBody from "../Text/TextBody";
import TextBody2 from "../Text/TextBody2";
import TextHead from "../Text/TextHead";
import TextPrice from "../Text/TextPrice";
import TextPriceOld from "../Text/TextPriceOld";
import TextQuantity from "../Text/TextQuantity";
import TextOutOfStock from "../Text/TextOutOfStock";
import {
  AppBar,
  Box,
  Divider,
  Paper,
  Tab,
  Tabs,
  Typography,
  IconButton,
  Grid,
  Button,
  ButtonBase,
  ButtonGroup,
  Modal,
  Toolbar,
  Slide,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio
} from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {style} from '../../style';
const DetailStore = ({
  dataDetail,
  setDataDetail,
  setAddCart,
  addCart,
  setOpenDetail,
  infoStore,
  index = 0,
  orderType,
  user,
  discountMoneyStore
}) => {
  const [count, setCount] = useState(0);
  const [checkCount, setCheckCount] = useState(0);
  useEffect(() => {
    if (dataDetail.quantity === 0) {
      setCheckCount(1)
      setCount(1);
    } else {
      setCheckCount(dataDetail.quantity)
      setCount(dataDetail.quantity);
    }
  }, []);
  const btnOffDetail = () => {
    setDataDetail({});
    setCount(dataDetail.quantity);
    setOpenDetail(false);
  };
  const btnAddToCard = () => {
    let countIsAuthen = checkCount
    countIsAuthen = countIsAuthen + 1
    setCheckCount(countIsAuthen)
    let addCount = count;
    addCount = addCount + 1;
    setCount(_.cloneDeep(addCount));
  };
  const removeFromCart = (data) => {
    if (count > 0) {
      let removeCount = count;
      removeCount = count - 1;
      setCount(_.cloneDeep(removeCount));
    }
  };
  const btnsubmit = (data) => {
    if (count >= 0) {
      dataDetail.quantity = count;
      var index = _.findIndex(addCart, (item) => item._id === data._id);
      if (index !== -1) {
        addCart[index].quantity = count;
      } else {
        addCart.push(data);
      }
      localStorage.setItem("list-carts", JSON.stringify(addCart));
      setAddCart(_.cloneDeep(addCart));
      btnOffDetail(data);
    } else {
      btnOffDetail(data);
    }
  };
  let showPrice = dataDetail.pricePromote, oldPrice = dataDetail.price === dataDetail.pricePromote ? null : dataDetail.price, basePrice = count * showPrice

  return (
    <Box sx={style}>
    <Box sx={{position: 'relative', marginBottom: '64px'}}>
      <AppBar
        position="sticky"
        color="inherit"
      >
        <Toolbar sx={{minHeight: '52px'}}>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={btnOffDetail}
          >
            <ArrowBackIcon fontSize="large"/>
          </IconButton>
          <TextTitle1 variant="h5" component="div">
            Chi tiết món
          </TextTitle1>

        </Toolbar>
      </AppBar>
      <Box>
        <img width="100%" height="auto" src={typeof dataDetail.images === 'string' ? dataDetail.images : dataDetail.images[0]}/>
        <Box sx={{ bgcolor: '#ffffff', padding: '16px'}} p={2}>
          <Box sx={{display: 'flex', alignItems: 'start', cursor: 'pointer'}}>
            <Box sx={{flexGrow: 1}}>
              <TextHead component="strong">
                {dataDetail.name}
              </TextHead>
            </Box>
            <Box sx={{display: 'flex', flexDirection: 'column'}}>
            {
              showPrice && <TextHead component="strong" color={"#000000"}>
                {moneyFormat(showPrice)}
              </TextHead>
            }
            {
              oldPrice && <TextPriceOld component="span" color="#929394">
                {moneyFormat(oldPrice)}
              </TextPriceOld>
            }
            </Box>
          </Box>
          <Box mt={1} sx={{bgcolor: '#ffffff'}}>
            <TextBody2>
              {dataDetail.description || 'Không có mô tả'}
            </TextBody2>
          </Box>
        </Box>

      </Box>
      <Box sx={{position: 'fixed', maxWidth:'600px', width: '100%', bottom: 0, display: 'flex', bgcolor: '#ffffff', padding: '12px 16px', zIndex: 1}}>
        <ButtonGroup size="small" variant="text" aria-label="text button group">
          <IconButton onClick={(e)=>{
            e.stopPropagation()
            removeFromCart(dataDetail)
          }}><i className="icon-minus-square" style={{fontSize: '24px', color: '#b0bec5'}}/></IconButton>
          <IconButton><TextQuantity component="span">{count}</TextQuantity></IconButton>
          <IconButton onClick={(e)=>{
            e.stopPropagation()
            btnAddToCard()
          }}><i className="icon-add-square" style={{fontSize: '24px', color: '#1589D8'}}/></IconButton>
        </ButtonGroup>
        <ButtonGroup onClick={() => btnsubmit(dataDetail)} sx={{flexGrow: 1}} size="small" variant="text" aria-label="text button group">
          <Button fullWidth variant="contained" sx={{borderRadius: '16px', fontSize: '16px', bgcolor: '#1589D8'}}>{dataDetail.isAvailable ? `Cập nhật • ${moneyFormat(basePrice)}` : 'Hết hàng'}</Button>
        </ButtonGroup>
      </Box>
    </Box>
    </Box>
  );
};
export default DetailStore;
